module.exports = __webpack_public_path__ + "img/instructions3.111232c2.png";